import React from 'react';
import { BiGroup, BiBook, BiBuilding, BiTime } from 'react-icons/bi';
import StatCard from '../common/StatCard';

const statsData = [
  { icon: BiGroup,    number: 1500, suffix: '+', label: 'Students Enrolled' },
  { icon: BiBook,     number: 80,   suffix: '+', label: 'Qualified Teachers' },
  { icon: BiBuilding, number: 30,   suffix: '+', label: 'Smart Classrooms' },
  { icon: BiTime,     number: 25,   suffix: '+', label: 'Years of Excellence' },
];

const SectionLabel = ({ text }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className="w-8 h-1 rounded-full bg-[#2563EB]" />
    <span className="text-[#2563EB] text-xs font-bold uppercase tracking-[0.25em]">{text}</span>
  </div>
);

const StatsSection = () => (
  <section className="py-20 lg:py-28 bg-[#F0F4FF]">
    <div className="max-w-7xl mx-auto px-8 sm:px-12 lg:px-16">
      <div className="mb-16">
        <SectionLabel text="Our Impact" />
        <h2 className="text-4xl sm:text-5xl font-bold text-[#0F172A] tracking-tight">
          School in <span className="text-[#2563EB]">Numbers</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {statsData.map((stat, idx) => (
          <StatCard key={idx} icon={stat.icon} number={stat.number} suffix={stat.suffix} label={stat.label} delay={idx * 0.15} />
        ))}
      </div>
    </div>
  </section>
);

export default StatsSection;
